/** Speaker/volume icon for the Audio Workspace gutter button. */

interface Props {
  width?: number;
  height?: number;
  className?: string;
}

export function SpeakerIcon({ width = 20, height = 20, className }: Props) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" className={className}>
      {/* Speaker body */}
      <path
        d="M3 7.5h3l4-3.5v12l-4-3.5H3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1z"
        fill="currentColor"
      />
      {/* Sound waves */}
      <path
        d="M13 7.5a3.5 3.5 0 0 1 0 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M15.5 5.5a6.5 6.5 0 0 1 0 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        opacity="0.6"
      />
    </svg>
  );
}
